module.exports = __webpack_public_path__ + "img/instagram-icon.7507bd08.svg";